import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './style.css';
import Router from './Router/Router';
function App() {
  return (
    <div className="App">
      <Router/>
    </div>
  );
}

export default App;
